import React, { Component } from "react";
import "./venta.scss";
import { Col, Container, Row, Form, FormGroup, Label, Button, Input,Table } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import Lottie from 'lottie-react-web'
import animationData from "../../../lotties/33623-piggy-bank-loop.json";

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
const customStyles = {
  control: styles => ({ ...styles, backgroundColor: '#fff', height: 42, width: '90%', margin: '0 auto', marginBottom: 20, }),
}

class MainProgresoPage extends Component {
  constructor(props) {
    super(props);
    // this.__getProgreso = this.__getProgreso.bind(this)
    this.state = {
      arrListUtilidades: [],
      isLoading: true,
      arrSucursales: [
        {id_sucursal: '0', nombre: 'DIRECCION', label: 'DIRECCION', value: 'DIRECCION', },
        {id_sucursal: '5f2067c915291', nombre: 'BELLAVISTA', label: 'BELLAVISTA', value: 'BELLAVISTA', },
        {id_sucursal: '5f206899a20c8', nombre: 'INGENIO', label: 'INGENIO', value: 'INGENIO', },
        {id_sucursal: '5f2071cb03380', nombre: 'ECOCENTRAL', label: 'ECOCENTRAL', value: 'ECOCENTRAL', },
        {id_sucursal: '5f2071cb0ww32', nombre: 'RUTA', label: 'RUTA', value: 'RUTA', },
        {id_sucursal: '5f2073022efb6', nombre: 'MADERO', label: 'MADERO', value: 'MADERO', },
        {id_sucursal: 'almacen', nombre: 'ALMACEN', label: 'ALMACEN', value: 'ALMACEN', },
        {id_sucursal: '5f2067c914482', nombre: 'GMART', label: 'GMART', value: 'GMART', },
        {id_sucursal: 'madero2', nombre: 'MADERO 2', label: 'MADERO 2', value: 'MADERO 2', },
      ],

      id_sucursal_option: '5f2067c915291',
      year: moment().format('YYYY'),
      month: moment().format('MM'),
      dateAlmacen: moment().format('YYYY-MM-DD'),
    }
  }

  componentDidMount() {
    this.getListUtilidades();
  }


  handleChange = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({isLoading:true});
    this.getListUtilidades();
  }

  makeTableData(value, index) {
    const {id_sucursal_option, arrListUtilidades} = this.state
    let prev_utilidad = 0
    let acum = 0;

    return arrListUtilidades.map((value, index) => {
      let utilidad = (value.venta_pesos + value.credito - value.venta_pcompra - value.gasto_fijo)
      return (
        <tr key={index}>
        <td>{value.fecha_venta}</td>
        <td>${this.convertToMoney(value.venta_pcompra)}</td>
        <td>${this.convertToMoney(value.venta_pesos)}</td>
        <td>${this.convertToMoney(value.credito)}</td>
        <td>${this.convertToMoney(value.cobranza)}</td>
        <td>${this.convertToMoney(value.gasto_proveedores)}</td>
        <td>${this.convertToMoney(value.gasto_fijo)}</td>
        <td>${this.convertToMoney(utilidad)}</td>
        { id_sucursal_option === '0' ? (
          <>
            <td>{this.convertToMoney(( (utilidad / 20000) * 100) ) }%</td>
            <td>{this.convertToMoney( ( (acum += utilidad) / ( 20000 * arrListUtilidades.length ) * 100 ))}%</td>
          </>
        ):(
          <>
            <td>{this.convertToMoney((utilidad  / 4000) * 100)}%</td>
            <td>{this.convertToMoney( ( (acum += utilidad) / ( 4000 * arrListUtilidades.length ) * 100 ))}%</td>
          </>
        )}
        </tr>
      )

      });
  }

  render() {
    const { arrListUtilidades, isLoading, arrSucursales, } = this.state
    return (
      <div className="directorPage__wrapper" style={{ backgroundColor: '#F8F8F9', borderRadius: '', marginTop: 0, }}>
        {/* Principal div */}
        <Container>
            <Row>
              <Col>
                <Select
                  placeholder="BELLAVISTA"
                  options={arrSucursales}
                  onChange={(val) => { this.setState({id_sucursal_option: val.id_sucursal}, this.getListUtilidades) }}
                  styles={customStylesOption}
                />
              </Col>
              <Col>
                <Row>
                  <Col>
                    <input
                      type={'date'}
                      value={ this.state.dateAlmacen }
                      onChange={(e) => { this.setState({ dateAlmacen: e.target.value }) }}
                      className={'regVentaPage__input_date'}
                    />
                  </Col>
                  <Col>
                    <p className={'btn btn-primary'} onClick={() => { this.getListUtilidades() }}>Generar</p>
                  </Col>
                </Row>
              </Col>
            </Row>

              {
                isLoading ? (
                <h3>Cargando...</h3>
              ) : (
                <Table>
                <thead>
                  <tr>
                    <th>Fecha venta</th>
                    {/*<th>Venta kg</th>*/}
                    <th>Compra pesos</th>
                    <th>Venta pesos</th>
                    <th>Crédito</th>
                    <th>Cobranza</th>
                    <th>Gasto proveedores</th>
                    <th>Gasto fijo</th>
                    <th>Utilidad</th>
                    <th>%</th>
                    <th>Acumulado</th>
                  </tr>
                </thead>
                <tbody>
                {
                  arrListUtilidades.length === 0 ? (
                    <tr><td colSpan={6}>No hay datos disponibles</td></tr>
                  ) : (
                    this.makeTableData()
                  )
                }
                </tbody>
                </Table>
              )}

        </Container>
      </div>
    );
  }

  getListUtilidades = (e) => {
    const { dateAlmacen, id_sucursal_option, } = this.state
    let year = moment(dateAlmacen).format('YYYY')
    let month = moment(dateAlmacen).format('MM')

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerPreproduction.php?opt=getListGeneralUtilidades2", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({
        year,
        month,
        id_sucursal: id_sucursal_option,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        this.setState({
          isLoading: false,
          arrListUtilidades: res.list,
        });

      });
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  convertToMoney(str) {
    if (str == null) str = 0;
    return parseFloat(str).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }
};

export default withRouter(MainProgresoPage)
